<template>
	<v-card>
		<v-card-text>
			<exploracion-fisica
				:validateForm="validar"
				:datos="valor.ExploracionFisica"
				@valorCambiado="valorCambiado($event, 'ExploracionFisica')"
				:esVisita="true"
			></exploracion-fisica>
			<valoracion-global-subjetiva
				:datos="valor.ValoracionGlobalSubjetiva"
				:validateForm="validar"
				@valorCambiado="
					valorCambiado($event, 'ValoracionGlobalSubjetiva')
				"
				:esVisita="true"
			></valoracion-global-subjetiva>
			<ant-per-pat-far
				:datos="valor.AntedecentesPersonales"
				:validateForm="validar"
				@valorCambiado="valorCambiado($event, 'AntedecentesPersonales')"
				:esVisita="true"
			></ant-per-pat-far>
			<terapia-reemplazo-renal
				:datos="valor.TerapiaRenal"
				:validateForm="validar"
				@valorCambiado="valorCambiado($event, 'TerapiaRenal')"
				:esVisita="true"
			></terapia-reemplazo-renal>
		</v-card-text>
		<v-footer app class="pt-3 d-print-none">
			<v-btn color="secondary" x-large @click.prevent="regresar"
				>Regresar <v-icon>chevron_left</v-icon></v-btn
			>
			<v-spacer></v-spacer>
			<v-btn color="primary" x-large @click.prevent="guardar"
				><v-icon>save</v-icon> Guardar
			</v-btn>
		</v-footer>
	</v-card>
</template>

<script>
import AntPerPatFar from "../historial-clinico/AntPerPatFar.vue";
import ExploracionFisica from "../historial-clinico/exploracionFisica.vue";
import TerapiaReemplazoRenal from "../historial-clinico/TerapiaReemplazoRenal.vue";
import ValoracionGlobalSubjetiva from "../historial-clinico/ValoracionGlobalSubjetiva.vue";
import ServicioVisita from "../../../services/visita";
export default {
	name: "clinicos",
	components: {
		ExploracionFisica,
		ValoracionGlobalSubjetiva,
		TerapiaReemplazoRenal,
		AntPerPatFar
	},
	async mounted() {
		await this.obtenerInfoPaso();
	},
	methods: {
		async obtenerInfoPaso() {
			const nombrePaso = "Clinicos";
			const res = await ServicioVisita.obtenerInfoPaso(
				nombrePaso,
				this.visitaId
			);
			if (res.data.result === 1 && res.data.data.Table0.length) {
				const valor = JSON.parse(res.data.data.Table0[0][nombrePaso]);
				if (valor) this.valor = valor;
			}
		},
		regresar() {
			this.$router.back();
		},
		valorCambiado(datos, key) {
			if (datos) {
				this.valor[key] = datos;
				this.ready++;
			} else {
				this.ready--;
			}
		},
		async guardar() {
			this.validar = true;
			// hack ?
			setTimeout(async () => {
				if (this.ready === 4) {
					const res = await ServicioVisita.guardarClinicos(
						this.visitaId,
						this.valor
					);

					if (res.data.result === 1) {
						this.$router.back();
					} else {
						this.$root.mensajeError = res.data.message;
					}
				} else {
					this.$root.mensajeError =
						"Por favor llene los campos requeridos.";
					this.validar = false;
				}
				this.ready = 0;
			}, 200);
		}
	},
	data() {
		return {
			valor: {},
			validar: false,
			ready: 0
		};
	},
	computed: {
		visitaId() {
			return this.$route.params.visitaId;
		}
	}
};
</script>

<style></style>
